import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) { }
  transform(value: any): any {
    return this.sanitized.bypassSecurityTrustHtml(value)
  }
}

@Pipe({ name: 'mathRound' })
export class MathRoundPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) { }
  transform(value: any): any {
    if (value.split('.')[1] == 0) {
      return Math.floor(value)
    } else {
      return value
    }
  }
}
@Pipe({ name: 'safeSrc' })
export class safeSrcPipe implements PipeTransform {
  constructor(public sanitizer: DomSanitizer) { }
  transform(value: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }
}